import { useQuery } from '@tanstack/react-query';
import { getCategories } from '../services/categories.service';

/**
 * Hook to fetch categories list
 * Categories change infrequently so we use a long staleTime
 */
export const useCategories = () => {
  return useQuery({
    queryKey: ['categories'],
    queryFn: getCategories,
    staleTime: 1000 * 60 * 30, // 30 minutes
  });
};
